module.exports =  firebaseConfig = {
    apiKey: "AIzaSyCk4BKBDdao9fB0_gfeVZ5DKEW-91NRY7I",
    authDomain: "theimg-e296e.firebaseapp.com",
    databaseURL: "https://theimg-e296e-default-rtdb.firebaseio.com",
    projectId: "theimg-e296e",
    storageBucket: "theimg-e296e.appspot.com",
    messagingSenderId: "704520067319",
    appId: "1:704520067319:web:c2722431aab1e0863c1bf2",
    measurementId: "G-PLVVY1EMB8"
  };